export default __webpack_public_path__ + "static/media/pass-watch.0f483680.svg";